import { API_URL } from 'utils';

export const loginService = async ({ payload }) => {
  const headers = {
    'Content-Type': 'application/json',
  };

  const tokenParams = {
    headers,
    method: 'POST',
    body: JSON.stringify(payload),
  };

  const authParams = (token, method = 'GET') => ({
    headers: {
      ...headers,
      authorization: `Bearer ${token}`,
    },
    method,
  });

  try {
    const loginResponse = await fetch(`${API_URL}/sso/login`, tokenParams).then(res => res.json());
    const { token } = loginResponse;

    if (token) {
      const { userId, roles, licences } = await fetch(
        `${API_URL}/sso/validate`,
        authParams(token, 'PUT'),
      ).then(res => res.json());

      const { data: user } = await fetch(
        `${API_URL}/sso/users/${userId}`,
        authParams(token),
      ).then(res => res.json());

      const { data: organisation } = await fetch(
        `${API_URL}/sso/organisations/${user.organisationId}`,
        authParams(token),
      ).then(res => res.json());

      return {
        token,
        organisation,
        roles,
        licences,
        user,
      };
    }

    throw loginResponse;
  } catch (response) {
    return response;
  }
};
